import { FC, Dispatch, SetStateAction } from "react";
import { Modal } from "shared/components";
import { UseMutateFunction } from "@tanstack/react-query";
import { Application } from "types/application";
import { Switch } from "shared/components/forms/Switch";
import { Button, ButtonSize, ButtonVariant } from "shared/components";

type UndoDecisionModalProps = {
  opened: boolean;
  onClose: () => void;
  onUndo: UseMutateFunction<Application, Error, void, unknown>;
  notifyApplicant: boolean;
  setNotifyApplicant: Dispatch<SetStateAction<boolean>>;
  undoDecisionPending: boolean;
};

export const UndoDecisionModal: FC<UndoDecisionModalProps> = ({
  opened,
  onClose,
  onUndo,
  notifyApplicant,
  setNotifyApplicant,
  undoDecisionPending
}) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      panelClassName="w-[400px] border border-alpha-100 shadow-xl"
    >
      <div className="px-6 pt-4 pb-2">
        <h1 className="text-xl font-bold text-content-1000 text-center">
          Undo decision?
        </h1>
        <p className="text-base text-center text-content-500 mt-2">
          The decision will be reverted. Application will return to the
          &lsquo;Pending Decision&rsquo; status.
        </p>
      </div>

      <Switch
        className="py-4 ml-2"
        checked={notifyApplicant}
        wrapperClassName="mx-6 my-4 border-y border-alpha-40"
        label="Notify applicant of this change via email"
        onChange={(value) => setNotifyApplicant(value)}
      />

      <div className="flex items-center gap-4 px-6 py-4">
        <Button
          variant={ButtonVariant.BASE}
          size={ButtonSize.BASE}
          onClick={onClose}
          className="w-full"
        >
          Cancel
        </Button>
        <Button
          size={ButtonSize.BASE}
          variant={ButtonVariant.PRIMARY}
          className="w-full"
          onClick={() => onUndo()}
          loading={undoDecisionPending}
          disabled={undoDecisionPending}
        >
          Undo
        </Button>
      </div>
    </Modal>
  );
};
